import { Component, Input, OnInit } from '@angular/core';
import { HelpService } from '@services/help.service';
import { Release } from '@classes/changeLog/release';
import { ChangeRubric } from '@classes/changeLog/changeRubric';
import { Change } from '@classes/changeLog/change';
import { ChangeCategory } from '@classes/changeLog/changeCategory';

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.scss']
})
export class ChangelogComponent implements OnInit {
    @Input() showAll: boolean = false;

    releases: TreeRelease[];

    constructor(private helpSrv: HelpService) {}

    ngOnInit(): void {
        const minDate = this.showAll ? new Date(2000, 1) : null;
        this.helpSrv.getChangLog(minDate).subscribe(log =>
            this.releases = log.releases
                .sort((a, b) => b.sortOrder - a.sortOrder)
                .map(release => new TreeRelease(release))
        );
    }
}

class TreeRelease
{
    version: string;
    date: Date;
    rubrics: TreeRubric[];

    constructor(release: Release) {
        this.version = release.code;
        this.date = release.date;

        this.rubrics = [...new Map(release.changes.map(change => [change.rubric.code, change.rubric])).values()]
            .sort((a, b) => a.sortOrder - b.sortOrder)
            .map(rubric => new TreeRubric(rubric, release.changes));
    }
}

class TreeRubric
{
    label: string;
    changes: TreeChange[];

    constructor(rubric: ChangeRubric, changes: Change[]) {
        this.label = rubric.label;
        this.changes = changes
            .filter(change => change.rubric.code === rubric.code)
            .sort((a, b) => a.sortOrder - b.sortOrder)
            .map(change => new TreeChange(change));
    }
}

class TreeChange
{
    category : TreeChangeCategory;
    text: string;

    constructor(change: Change) {
        this.category = new TreeChangeCategory(change.category);
        this.text     = change.text                            ;
    }
}

class TreeChangeCategory
{
    code : string;
    label: string;

    text: string;

    constructor(category: ChangeCategory) {
        this.code  = category.code ;
        this.label = category.label;
    }

    get icon(): string
    {
        switch (this.code)
        {
            case 'added'     : return 'add_circle_outline'   ;
            case 'changed'   : return 'update'               ;
            case 'deprecated': return 'pause_circle_outline' ;
            case 'removed'   : return 'remove_circle_outline';
            case 'fixed'     : return 'check_circle_outline' ;
            case 'perf'      : return 'access_time'          ;
            case 'security'  : return 'security'             ;
        }
    }
}
